import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWho } from './components/ForWho';
import { MethodOverview } from './components/MethodOverview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { KitUpsell } from './components/KitUpsell';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { StickyCta } from './components/StickyCta';
import { PurchasePopup } from './components/PurchasePopup';
interface AppProps {
  /** Horas que dura la cuenta regresiva de lanzamiento */
  horasDeLanzamiento?: number;
  /** Porcentaje de cupos ya tomados */
  cuposTomados?: number;
  /** Barra de compra fija en móvil */
  barraDeCompraMovil?: boolean;
  /** Avisos de "compra verificada" cada 40-60 segundos */
  popupDeCompras?: boolean;
  /** ID del Meta Pixel (evento PageView) */
  metaPixelId?: string;
}
export function App({
  horasDeLanzamiento = 23,
  cuposTomados = 68,
  barraDeCompraMovil = true,
  popupDeCompras = true,
  metaPixelId = '950420514112134'
}: AppProps) {
  useMetaPixel(metaPixelId);
  return <div className="w-full bg-cream-50 pb-16 font-sans md:pb-0" data-id="element-0" data-mp="2zng32ospcsv1">
      <Hero data-id="element-1" data-mp="33n6zb810016y" />
      <Testimonials data-id="element-2" data-mp="33myl9ct52pu6" />
      <main data-id="element-3" data-mp="33oi0d0326uud">
        <PainPoints data-id="element-4" data-mp="38m1elzzrb7mb" />
        <ForWho data-id="element-5" data-mp="38li6tc3tlzm0" />
        <MethodOverview data-id="element-6" data-mp="38l06o4e1f18t" />
        <Tomos data-id="element-7" data-mp="38nuodo5o27yj" />
        <Bonos data-id="element-8" data-mp="3dkuuu06fhcq6" />
        <Comparison data-id="element-9" data-mp="3dkl0y1i9ilf7" />
        <Pricing durationHours={horasDeLanzamiento} cuposTomados={cuposTomados} data-id="element-10" data-mp="3dlw6a5rcw18f" />
        <KitUpsell data-id="element-11" data-mp="nw2cw89b1us5" />
        <Guarantee data-id="element-12" data-mp="nuhiqjqwkdut" />
        <Faq data-id="element-13" data-mp="nv12m6045cbh" />
        <FinalCta durationHours={horasDeLanzamiento} data-id="element-14" data-mp="nxn4pq48izmb" />
      </main>
      <SiteFooter data-id="element-15" data-mp="stc8k5naf2of" />
      {barraDeCompraMovil ? <StickyCta durationHours={horasDeLanzamiento} data-id="element-16" data-mp="swglpsiqd8r8" /> : null}
      {popupDeCompras ? <PurchasePopup data-id="element-17" data-mp="34nd1wz277z9" /> : null}
    </div>;
}